/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { error } from '@/libs/notification';
import router from '@/router';
import {
  AutobacsDevicesState,
  AutobacsDevicesDataState,
  AutobacsDevicesFilterData
} from '@/types/autobacsDevice';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    listData: [],
    readyListData: [],
    filterData: null
  },
  mutations: {
    setList(state: AutobacsDevicesState, payload: AutobacsDevicesDataState[]) {
      state.listData = payload;
    },
    setReadyList(
      state: AutobacsDevicesState,
      payload: AutobacsDevicesDataState[]
    ) {
      state.readyListData = payload;
    },
    setFilter(state: AutobacsDevicesState, payload: AutobacsDevicesFilterData) {
      state.filterData = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      await axios
        .get(getBaseUrl() + '/autobacs/device', {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          const sortData = response.data.sort(
            (a: AutobacsDevicesDataState, b: AutobacsDevicesDataState) => {
              if (a.id > b.id) {
                return -1;
              }
              return 1;
            }
          );
          context.commit('setList', sortData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          }
          if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async fetchReady(context: any) {
      await axios
        .get(getBaseUrl() + '/autobacs/device', {
          params: {
            status: [2]
          },
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setReadyList', response.data);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          }
          if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async setFilterData(context: any, payload: AutobacsDevicesFilterData) {
      context.commit('setFilter', payload);
    }
  }
};
